export const EMAIL_REGEX = /\b[\w.-]+@[\w.-]+\.\w{2,}\b/

export const PHONE_REGEX = /^\s*(?:\+?(\d{1,}))?([-. (]*(\d{1,})[-. )]*)?((\d{1,})[-. ]*(\d{1,})(?:[-.x ]*(\d+))?)\s*$/
